
import './CampaignSchedules.scss'
import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, Form, Spinner, Button, Modal } from 'react-bootstrap';
import { useMutation } from '@apollo/client';
import { useFormik } from "formik";
import * as Yup from "yup";
import { GET_ALL_CAMPAIGN } from '../../../gql/campaign/queries';
import { GET_CAMPAIGN_DETAILS_BY_ID } from '../../../gql/campaign/mutation';
import { GET_TIMEZONE } from '../../../gql/campaign/schedule/queries';
import { ADD_SCHEDULE, GET_SCHEDULED_DATA } from '../../../gql/campaign/schedule/mutation';
import useUnsavedChangeWarning from '../../../hooks/useUnsavedChangeWarning';
import warningIcon from '../../../assets/images/warningIcon.svg';
import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { UPDATE_CAMPAIGN_STATUS } from '../../../gql/campaign/mutation';
import playIcon from '../../../assets/images/play-icon.png';


function CampaignSchedules() {
    const { id } = useParams()
    const history = useHistory()
    const [allCampaign, setAllCampaign] = useState([])
    const [clickedCampaign, setClickedCampaign] = useState({})
    const [errorMessage, setErrorMessage] = useState('')
    const [sameEveryDay, setSameEveryDay] = useState(false);
    const [scheduleDays, setScheduleDays] = useState([])
    const [scheduleSuccess, setScheduleSuccess] = useState(false)
    const [timeZone, setTimeZone] = useState([])
    const [scheduleTimeZoneName, setScheduleTimeZoneName] = useState('')
    const [updateSuccess, setUpdateSuccess] = useState(false)
    const [smShow2, setSmShow2] = useState(false);
    const [updatePlaySuccess, setUpdatePlaySuccess] = useState(false)
    //eslint-disable-next-line
    const [campaignStarted, setCampaignStarted] = useState(false)
    const [updatePauseSuccess, setUpdatePauseSuccess] = useState(false)
    const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()

    //timpicker
    //eslint-disable-next-line
    const [isBetweenDrop, setIsBetweenDrop] = useState(false);
    //eslint-disable-next-line
    const [betweenHour, setBetweenHour] = useState("");
    //eslint-disable-next-line
    const [betweenMin, setBetweenMin] = useState("");
    //eslint-disable-next-line
    const [andHour, setAndHour] = useState("");
    //eslint-disable-next-line
    const [andMin, setAndMin] = useState("");
    // const [betweenTime, setBetweenTime] = useState("");
    // const [andTime, setAndTime] = useState("");
    //eslint-disable-next-line
    const [isAndDrop, setIsAndDrop] = useState(false);
    // timepicker

    const formik = useFormik({
        initialValues: {
            scheduleName: "",
            // scheduleDays: [0, 3, 6],    //scheduleDays
            scheduleStartTime: "",  //between
            scheduleEndTime: "",     // and
            delayInterval: "",   //reach a new lead everday in minutes
            scheduleTimeZone: "",
            scheduleTimeZoneName: "",
        },
        validationSchema: Yup.object({
            scheduleName: Yup.string()
                .required("Schedule name is required"),

            scheduleStartTime: Yup.string()
                .required("This field is required"),

            scheduleEndTime: Yup.string()
                .required("This field is required"),

            delayInterval: Yup.string()
                .required("This field is required"),

            scheduleTimeZone: Yup.string()
                .required("Time Zone is required")
        }),
        onSubmit: (values) => {
            try {
                if (!id) {
                    return toast.error('Choose Campaign First.', {
                        position: "bottom-right",
                        closeOnClick: true,
                    })
                }

                if (!values.scheduleName || !values.scheduleName.trim()) {
                    return toast.error("Schedule Name Required.", {
                        position: "bottom-right",
                    })
                }

                if (scheduleDays.length === 0) {
                    return toast.error("Day is required", {
                        position: "bottom-right",
                        closeOnClick: true,
                    })
                }

                addSchedule({
                    variables: {
                        campaignScheduleInput: {
                            campaignId: id,
                            scheduleData: {
                                delayInterval: values.delayInterval,
                                scheduleDays: scheduleDays,
                                scheduleEndTime: values.scheduleEndTime,
                                // scheduleEndTime: `${andHour}:${andMin}`,
                                scheduleStartTime: values.scheduleStartTime,
                                // scheduleStartTime: `${betweenHour}:${betweenMin}`,
                                scheduleName: values.scheduleName,
                                scheduleTimeZone: values.scheduleTimeZone,
                                scheduleTimeZoneName: scheduleTimeZoneName
                            }
                        }
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })


    const [getAllCampaign] = useLazyQuery(GET_ALL_CAMPAIGN, {
        onCompleted(data) {
            setAllCampaign(data?.getAllCampaign)
        }
    })

    const [getCampaignById] = useMutation(GET_CAMPAIGN_DETAILS_BY_ID, {
        onCompleted(data) {
            if (data?.getAllSequences) {
                setClickedCampaign(data.getAllSequences)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        fetchPolicy: 'network-only'
    })

    const [getTimeZone] = useLazyQuery(GET_TIMEZONE, {
        onCompleted(data) {
            setTimeZone(data?.getTimeZones)
        }
    })

    const [addSchedule, { loading }] = useMutation(ADD_SCHEDULE, {
        onCompleted(data) {
            setScheduleSuccess(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [getScheduledData, { loading: getScheduledDataLoading }] = useMutation(GET_SCHEDULED_DATA, {
        onCompleted(data) {
            formik.values.scheduleName = data?.getCampaignSchedule?.schedule?.scheduleName ?? ""
            formik.values.scheduleStartTime = data?.getCampaignSchedule?.schedule?.scheduleStartTime ? data?.getCampaignSchedule?.schedule?.scheduleStartTime : ""
            formik.values.scheduleEndTime = data?.getCampaignSchedule?.schedule?.scheduleEndTime ? data?.getCampaignSchedule?.schedule?.scheduleEndTime : ""
            formik.values.delayInterval = data?.getCampaignSchedule?.schedule?.delayInterval ?? ""
            formik.values.scheduleTimeZone = data?.getCampaignSchedule?.schedule?.scheduleTimeZone ?? ""
            formik.values.scheduleTimeZoneName = data?.getCampaignSchedule?.schedule?.scheduleTimeZoneName ?? ""
            setScheduleDays(data?.getCampaignSchedule?.schedule?.scheduleDays ?? [])
            setSameEveryDay(data?.getCampaignSchedule?.schedule?.scheduleDays.length === 7 ? true : false)
            setScheduleTimeZoneName(data?.getCampaignSchedule?.schedule?.scheduleTimeZoneName)
            let between_time = data?.getCampaignSchedule?.schedule?.scheduleStartTime ? data?.getCampaignSchedule?.schedule?.scheduleStartTime.split(':') : ""
            let and_time = data?.getCampaignSchedule?.schedule?.scheduleEndTime ? data?.getCampaignSchedule?.schedule?.scheduleEndTime.split(':') : ""
            setBetweenHour(between_time[0])
            setBetweenMin(between_time[1])
            setAndHour(and_time[0])
            setAndMin(and_time[1])

        },
        fetchPolicy: 'network-only'
    })

    const [updateCampaignStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setUpdateSuccess(true)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    const [updateCampaignPlayStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setClickedCampaign({
                    ...clickedCampaign,
                    campaignStarted: true
                })
                setUpdatePlaySuccess(true)
                setCampaignStarted(true)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    const [updateCampaignPauseStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setClickedCampaign({
                    ...clickedCampaign,
                    campaignStarted: false
                })
                setUpdatePauseSuccess(true)
                setCampaignStarted(false)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    useEffect(() => {
        getAllCampaign()
        getTimeZone()

        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (id) {
            getCampaignById({
                variables: {
                    getSequenceArgs: {
                        campaignId: id
                    }
                }
            })
        }

        //eslint-disable-next-line
    }, [id])

    useEffect(() => {
        if (id) {
            getScheduledData({
                variables: {
                    campaignId: id
                }
            })
        }

        //eslint-disable-next-line
    }, [id])

    const weekDays = [
        { type: "MON", value: 1 },
        { type: "TUE", value: 2 },
        { type: "WED", value: 3 },
        { type: "THU", value: 4 },
        { type: "FRI", value: 5 },
        { type: "SAT", value: 6 },
        { type: "SUN", value: 0 },
    ];

    if (errorMessage) {
        toast.error(errorMessage, {
            position: "bottom-right",
            closeOnClick: true,
        })
        setErrorMessage('')
    }

    if (scheduleSuccess) {
        toast.success("Successfully Saved.", {
            position: "bottom-right",
        })
        setPristine()
        setScheduleSuccess(false)
    }

    const handleDeleteCampaign = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'DELETE'
                }
            }
        })
    }

    if (updateSuccess) {
        setSmShow2(false)
        setClickedCampaign({})
        setSameEveryDay(false)
        setBetweenHour("")
        setBetweenMin("")
        setAndHour("")
        setAndMin("")
        formik.values.scheduleName = ""
        formik.values.scheduleStartTime = ""
        formik.values.scheduleEndTime = ""
        formik.values.delayInterval = ""
        formik.values.scheduleTimeZone = ""
        formik.values.scheduleTimeZoneName = ""
        formik.resetForm()
        setScheduleDays([])
        setScheduleTimeZoneName('')
        history.push('/campaigns/schedule')
        toast.success('Campaign Deleted.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdateSuccess(false)
    }

    const handlePause = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignPauseStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'PAUSE'
                }
            }
        })
    }

    const handlePlay = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignPlayStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'START'
                }
            }
        })
    }

    if (updatePlaySuccess) {
        toast.success('Campaign Started.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdatePlaySuccess(false)
    }

    if (updatePauseSuccess) {
        toast.success('Campaign Paused.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdatePauseSuccess(false)
    }

    
    return (
        <>
            {/* <CampaignsSidebar allCampaign={allCampaign} /> */}

            <div className='campaign-sidebar'>
                <div className='title'>
                    <h4>Campaigns</h4>
                </div>
                <div className='campaign_list_container' >
                    <ul>
                        {
                            allCampaign && allCampaign.length > 0 && allCampaign.map((item, i) => {
                                if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'autoScript' && item?.sequence.length > 0)) {
                                    return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                                        <Link to={`/campaigns/schedule/${item?._id}`}
                                            onClick={() => {
                                                setPristine()
                                                setClickedCampaign(item)
                                            }}
                                        >
                                            {item?.campaignName}
                                        </Link>
                                    </li>
                                }
                                else if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'manualScript')) {
                                    return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                                        <Link to={`/campaigns/schedule/${item?._id}`}
                                            onClick={() => {
                                                setPristine()
                                                setClickedCampaign(item)
                                            }}
                                        >
                                            {item?.campaignName}
                                        </Link>
                                    </li>
                                }
                                return false
                            })
                        }
                    </ul>
                </div>
                <div className='create-camp-btn'>
                    <button className='solid-button'
                        onClick={() => {
                            setIsDirty()
                            history.push('/campaign-name')
                        }}
                    >
                        Create New Campaigns
                    </button>
                </div>
            </div>

            <div className='campaign-details'>
                <div className='title-btn-container'>
                    <h1>{clickedCampaign?.campaignName}</h1>
                    <div className='btn-container'>
                        <button className='play-pause-btn'>
                            {
                                // clickedCampaign?.campaignStarted === true || campaignStarted === true ?
                                clickedCampaign?.campaignStarted === true ?
                                    <span className='pause' onClick={handlePause} >
                                        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        Pause
                                    </span>
                                    :
                                    <span className='play' onClick={handlePlay} >
                                        {/* <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg> */}
                                        <img src={playIcon} alt="play" width="20" height="20" />
                                        Play
                                    </span>

                            }
                        </button>
                        {
                            loading ?
                                <button className='solid-button' >Save &nbsp;
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </button>
                                :
                                <label htmlFor="submit-form" className='solid_button_save_schedule' >Save</label>

                        }
                        {/* <label htmlFor="submit-form" className='solid_button_save_schedule' >Save</label> */}
                        <button className='delete-btn' onClick={() => setSmShow2(true)}>
                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.998047 4.40332H2.86471H17.798" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.66719 4.39935V2.53268C5.66719 2.03761 5.86385 1.56282 6.21392 1.21275C6.56399 0.862682 7.03878 0.666016 7.53385 0.666016H11.2672C11.7623 0.666016 12.2371 0.862682 12.5871 1.21275C12.9372 1.56282 13.1339 2.03761 13.1339 2.53268V4.39935M15.9339 4.39935V17.466C15.9339 17.9611 15.7372 18.4359 15.3871 18.7859C15.0371 19.136 14.5623 19.3327 14.0672 19.3327H4.73385C4.23878 19.3327 3.76399 19.136 3.41392 18.7859C3.06385 18.4359 2.86719 17.9611 2.86719 17.466V4.39935H15.9339Z" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <ul className='campaign-detail-tabs'>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/leads/${id}` : '/campaigns/leads'} >Leads</Link>
                    </li>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/campaign-details/${id}` : '/campaigns/campaign-details'}>Sequence</Link>
                    </li>
                    <li className='active'>
                        <Link to='#'>Schedules</Link>
                    </li>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/setup/${id}` : '/campaigns/setup'} >Setup</Link>
                    </li>
                </ul>
                {/* <CampaignsSequence /> */}

                <div className='sequence-container'>
                    <div className='sequence-wrap' style={{ width: '100%' }} >

                        <div className='sequence-content' style={{ flexBasis: 'calc(100% - 0px)' }} >
                            <div className='sequence-type'>
                                {
                                    getScheduledDataLoading ?
                                        <div className="spinner" >
                                            <Loaders
                                                type="ThreeDots"
                                                color="#192f60"
                                                height={70}
                                                width={70}
                                                timeout={3000}
                                            />
                                        </div>
                                        :

                                        <Form className="" onSubmit={formik.handleSubmit}>

                                            {/* your code */}

                                            <Row className="mb-4">
                                                <Form.Group as={Col} controlId="scheduleName">
                                                    <Form.Label>Schedule Name</Form.Label>
                                                    <Form.Control
                                                        name="scheduleName"
                                                        type="text"
                                                        placeholder=""
                                                        value={formik.values.scheduleName}
                                                        onChange={formik.handleChange}
                                                        onInput={() => setIsDirty()}
                                                        onBlur={formik.handleBlur}
                                                    // className={formik.errors.email && formik.touched.email && "error"}
                                                    />
                                                    {
                                                        formik.errors.scheduleName && formik.touched.scheduleName &&
                                                        (
                                                            <div className="input-feedback">{formik.errors.scheduleName}</div>
                                                        )
                                                    }
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-4">
                                                <Form.Group as={Col} style={{ position: 'relative' }} controlId="sameEveryDay">
                                                    <Form.Label>Set Standard Hours</Form.Label>
                                                    <Form.Control
                                                        name="sameEveryDay"
                                                        type="text"
                                                        placeholder="Same everyday"
                                                        readOnly
                                                        style={{ background: '#F5F8FA', width: '50%' }}
                                                    // className={formik.errors.email && formik.touched.email && "error"}
                                                    />
                                                    <Col>
                                                        <div className='toggle_everyDay' >
                                                            <Form.Check
                                                                className="allDays_switch"
                                                                type="switch"
                                                                id="custom-switch"
                                                                onChange={(e) => {
                                                                    setSameEveryDay(!sameEveryDay)
                                                                    if (e.target.checked === true) {
                                                                        let allDays = weekDays.map((item, i) => { return item.value })
                                                                        setScheduleDays(allDays)
                                                                    }
                                                                    else if (e.target.checked === false) {
                                                                        setScheduleDays([])
                                                                    }
                                                                }}
                                                                checked={sameEveryDay}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-4">
                                                <Form.Group as={Col} controlId="scheduleDays">
                                                    {/* <Form.Label>Schedule Name</Form.Label> */}
                                                    <div className='days_container' >
                                                        {
                                                            weekDays.map((item, i) => (
                                                                <div className="mt-2 days_input_box" key={i}>
                                                                    {/* {
                                                                sameEveryDay === false ? */}
                                                                    <input
                                                                        type="checkbox"
                                                                        name="scheduleDays"
                                                                        value={item.value}
                                                                        checked={scheduleDays.includes(item.value) ? true : false}
                                                                        // checked={true}
                                                                        className="btn-check"
                                                                        id={`btn-check-${i}`}
                                                                        autoComplete="off"
                                                                        onChange={(e) => {
                                                                            if (!scheduleDays.includes(item.value)) {
                                                                                setScheduleDays((prev) => [...prev, item.value])
                                                                            }
                                                                            else if (scheduleDays.includes(item.value)) {
                                                                                let filteredDays = scheduleDays.filter((day, i) => day !== item.value)
                                                                                setScheduleDays(filteredDays)

                                                                            }
                                                                        }}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    <label className="btn btn-outline-primary weekday-label days_name" htmlFor={`btn-check-${i}`} >
                                                                        {item.type}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-4">
                                                <Form.Group as={Col} controlId="scheduleStartTime" style={{ flex: '0 0 185px' }} >
                                                    <Form.Label>Between</Form.Label>
                                                    <Form.Select
                                                        name="scheduleStartTime"
                                                        aria-label="Default select example"
                                                        value={formik.values.scheduleStartTime.split(':')[0] + ':' + formik.values.scheduleStartTime.split(':')[1]}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        className="betweenSelect"
                                                    >
                                                        <option value="" disabled >Select</option>
                                                        <option value="00:00"  >0:00 AM</option>
                                                        <option value="00:30"  >0:30 AM</option>
                                                        <option value="01:00"  >1:00 AM</option>
                                                        <option value="01:30"  >1:30 AM</option>
                                                        <option value="02:00"  >2:00 AM</option>
                                                        <option value="02:30" >2:30 AM</option>
                                                        <option value="03:00"  >3:00 AM</option>
                                                        <option value="03:30"  >3:30 AM</option>
                                                        <option value="04:00"  >4:00 AM</option>
                                                        <option value="04:30"  >4:30 AM</option>
                                                        <option value="05:00"  >5:00 AM</option>
                                                        <option value="05:30"  >5:30 AM</option>
                                                        <option value="06:00"  >6:00 AM</option>
                                                        <option value="06:30"  >6:30 AM</option>
                                                        <option value="07:00"  >7:00 AM</option>
                                                        <option value="07:30"  >7:30 AM</option>
                                                        <option value="08:00"  >8:00 AM</option>
                                                        <option value="08:30"  >8:30 AM</option>
                                                        <option value="09:00"  >9:00 AM</option>
                                                        <option value="09:30"  >9:30 AM</option>
                                                        <option value="10:00"  >10:00 AM</option>
                                                        <option value="10:30"  >10:30 AM</option>
                                                        <option value="11:00"  >11:00 AM</option>
                                                        <option value="11:30"  >11:30 AM</option>
                                                        <option value="12:00"  >12:00 PM</option>
                                                        <option value="12:30"  >12:30 PM</option>
                                                        <option value="13:00" >1:00 PM</option>
                                                        <option value="13:30"  >1:30 PM</option>
                                                        <option value="14:00"  >2:00 PM</option>
                                                        <option value="14:30"  >2:30 PM</option>
                                                        <option value="15:00"  >3:00 PM</option>
                                                        <option value="15:30" >3:30 PM</option>
                                                        <option value="16:00"  >4:00 PM</option>
                                                        <option value="16:30"  >4:30 PM</option>
                                                        <option value="17:00" >5:00 PM</option>
                                                        <option value="17:30"  >5:30 PM</option>
                                                        <option value="18:00"  >6:00 PM</option>
                                                        <option value="18:30"  >6:30 PM</option>
                                                        <option value="19:00"  >7:00 PM</option>
                                                        <option value="19:30"  >7:30 PM</option>
                                                        <option value="20:00"  >8:00 PM</option>
                                                        <option value="20:30"  >8:30 PM</option>
                                                        <option value="21:00"  >9:00 PM</option>
                                                        <option value="21:30"  >9:30 PM</option>
                                                        <option value="22:00"   >10:00 PM</option>
                                                        <option value="22:30"  >10:30 PM</option>
                                                        <option value="23:00"  >11:00 PM</option>
                                                        <option value="23:30"  >11:30 PM</option>
                                                        <option value="23:59"  >11:59 PM</option>
                                                    </Form.Select>
                                                    {
                                                        formik.errors.scheduleStartTime && formik.touched.scheduleStartTime &&
                                                        (
                                                            <div className="input-feedback">{formik.errors.scheduleStartTime}</div>
                                                        )
                                                    }

                                                </Form.Group>

                                                <Form.Group as={Col} controlId="scheduleEndTime" style={{ flex: '0 0 185px' }} >
                                                    <Form.Label>And</Form.Label>
                                                    <Form.Select
                                                        name="scheduleEndTime"
                                                        aria-label="Default select example"
                                                        value={formik.values.scheduleEndTime.split(':')[0] + ':' + formik.values.scheduleEndTime.split(':')[1]}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        className="betweenSelect"
                                                    >
                                                        <option value="" disabled >Select</option>
                                                        <option value="00:00">0:00 AM</option>
                                                        <option value="00:30">0:30 AM</option>
                                                        <option value="01:00">1:00 AM</option>
                                                        <option value="01:30">1:30 AM</option>
                                                        <option value="02:00">2:00 AM</option>
                                                        <option value="02:30">2:30 AM</option>
                                                        <option value="03:00">3:00 AM</option>
                                                        <option value="03:30">3:30 AM</option>
                                                        <option value="04:00">4:00 AM</option>
                                                        <option value="04:30">4:30 AM</option>
                                                        <option value="05:00">5:00 AM</option>
                                                        <option value="05:30">5:30 AM</option>
                                                        <option value="06:00">6:00 AM</option>
                                                        <option value="06:30">6:30 AM</option>
                                                        <option value="07:00">7:00 AM</option>
                                                        <option value="07:30">7:30 AM</option>
                                                        <option value="08:00">8:00 AM</option>
                                                        <option value="08:30">8:30 AM</option>
                                                        <option value="09:00">9:00 AM</option>
                                                        <option value="09:30">9:30 AM</option>
                                                        <option value="10:00">10:00 AM</option>
                                                        <option value="10:30">10:30 AM</option>
                                                        <option value="11:00">11:00 AM</option>
                                                        <option value="11:30">11:30 AM</option>
                                                        <option value="12:00">12:00 PM</option>
                                                        <option value="12:30">12:30 PM</option>
                                                        <option value="13:00">1:00 PM</option>
                                                        <option value="13:30">1:30 PM</option>
                                                        <option value="14:00">2:00 PM</option>
                                                        <option value="14:30">2:30 PM</option>
                                                        <option value="15:00">3:00 PM</option>
                                                        <option value="15:30">3:30 PM</option>
                                                        <option value="16:00">4:00 PM</option>
                                                        <option value="16:30">4:30 PM</option>
                                                        <option value="17:00">5:00 PM</option>
                                                        <option value="17:30">5:30 PM</option>
                                                        <option value="18:00">6:00 PM</option>
                                                        <option value="18:30">6:30 PM</option>
                                                        <option value="19:00">7:00 PM</option>
                                                        <option value="19:30">7:30 PM</option>
                                                        <option value="20:00">8:00 PM</option>
                                                        <option value="20:30">8:30 PM</option>
                                                        <option value="21:00">9:00 PM</option>
                                                        <option value="21:30">9:30 PM</option>
                                                        <option value="22:00">10:00 PM</option>
                                                        <option value="22:30">10:30 PM</option>
                                                        <option value="23:00">11:00 PM</option>
                                                        <option value="23:30">11:30 PM</option>
                                                        <option value="23:59">11:59 PM</option>
                                                    </Form.Select>
                                                    {
                                                        formik.errors.scheduleEndTime && formik.touched.scheduleEndTime &&
                                                        (
                                                            <div className="input-feedback">{formik.errors.scheduleEndTime}</div>
                                                        )
                                                    }
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="delayInterval" style={{ flex: '0 0 200px' }} >
                                                    <Form.Label>Reach a new lead everyday</Form.Label>
                                                    <Form.Control
                                                        name="delayInterval"
                                                        type="number"
                                                        min="0"
                                                        value={formik.values.delayInterval}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        onInput={() => setIsDirty()}
                                                    // className={formik.errors.email && formik.touched.email && "error"}
                                                    />
                                                    {
                                                        formik.errors.delayInterval && formik.touched.delayInterval &&
                                                        (
                                                            <div className="input-feedback">{formik.errors.delayInterval}</div>
                                                        )
                                                    }
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="scheduleName" style={{ display: 'flex', alignItems: 'center', paddingTop: '2%', position: 'relative', }} >
                                                    <div style={{ marginRight: '17px' }} >
                                                        <span>minutes</span>
                                                    </div>
                                                </Form.Group>
                                            </Row>

                                            <Row className="mb-4">
                                                <Form.Group as={Col} controlId="scheduleTimeZone">
                                                    <Form.Label>Time Zone</Form.Label>
                                                    <Form.Select
                                                        name="scheduleTimeZone"
                                                        value={formik.values.scheduleTimeZone}
                                                        onChange={(e) => {
                                                            formik.handleChange(e)
                                                            const class_name = e.target.options[e.target.selectedIndex].dataset.class_name
                                                            setScheduleTimeZoneName(class_name)
                                                            formik.values.scheduleTimeZoneName = class_name
                                                            setIsDirty()
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        onFocus={() => {
                                                            setIsBetweenDrop(false)
                                                            setIsAndDrop(false)
                                                        }}
                                                        aria-label="Default select example"
                                                        className="select_box_timeZone"
                                                    // className={formik.errors.email && formik.touched.email && "error"}
                                                    >
                                                        <option value="" disabled >Select</option>
                                                        {
                                                            timeZone.length > 0 && timeZone.map((item, i) => (
                                                                <option value={item.timeZoneNumber} key={i} data-class_name={item.timeZoneName} >{item.timeZone}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                    {
                                                        formik.errors.scheduleTimeZone && formik.touched.scheduleTimeZone &&
                                                        (
                                                            <div className="input-feedback">{formik.errors.scheduleTimeZone}</div>
                                                        )
                                                    }
                                                </Form.Group>
                                            </Row>

                                            <Button className='solid-button' id="submit-form" type="submit" style={{ display: 'none' }}>Save</Button>

                                        </Form>
                                }

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Modal
                size="md"
                className='warning-modal'
                show={smShow2}
                onHide={() => setSmShow2(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className='warning-div'>
                        <img src={warningIcon} alt="warning" />
                        <h2>Warning</h2>
                        <p>Are you sure you want to delete this campaign?
                        </p>
                        <div className='btn-container'>
                            <button className='cancel-btn' onClick={() => setSmShow2(false)}>No</button>
                            <button className='solid-button' style={{ flex: "0 0 128px" }} onClick={handleDeleteCampaign} >
                                Yes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {Prompt}
        </>
    )
}

export default CampaignSchedules 
